import { useEffect, useState } from "react";
import { Modal, Button } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import trans from "../../../utils";
import { InputSelect } from "../../Helpers/Input/RefactoredInput";
import { useTechnicians } from "../../../hooks/useTechnicians";
import { useReassignDispatchPlanMutation } from "../../../Redux/service/Dispatcher/DispatcherPlan";

export default function ReassignDispatchPlanModal({ plan, onClose }) {
	const [assigneeId, setAssigneeId] = useState(undefined);
	const [touched, setTouched] = useState(false);

	const { options: assigneeOptions, isFetching: assigneesLoading } =
		useTechnicians();
	const [reassignDispatchPlan, { isLoading }] = useReassignDispatchPlanMutation();

	useEffect(() => {
		if (plan) {
			setAssigneeId(plan.assignedTo ? String(plan.assignedTo.id) : undefined);
			setTouched(false);
		}
	}, [plan]);

	const isInvalid = !assigneeId;

	const handleConfirm = async () => {
		setTouched(true);
		if (isInvalid) return;

		try {
			await reassignDispatchPlan({
				id: plan.id,
				technicianUserId: Number(assigneeId),
			}).unwrap();
			toast.success(trans("Dispatch plan reassigned successfully"), {
				autoClose: 2000,
			});
			onClose();
		} catch (error) {
			toast.error(
				trans(error?.data?.message) || trans("Failed to reassign dispatch plan"),
				{ autoClose: 3000 },
			);
		}
	};

	return (
		<Modal
			title={trans("Reassign")}
			open={!!plan}
			onCancel={onClose}
			maskClosable={false}
			centered
			footer={[
				<Button key="cancel" onClick={onClose} disabled={isLoading}>
					{trans("Cancel")}
				</Button>,
				<Button
					key="confirm"
					type="primary"
					loading={isLoading}
					onClick={handleConfirm}
				>
					{trans("Confirm Reassign")}
				</Button>,
			]}
		>
			<InputSelect
				id="reassignAssigneeId"
				name="reassignAssigneeId"
				label={trans("Assignee To")}
				placeholder={trans("Select field staff")}
				options={assigneeOptions}
				loading={assigneesLoading}
				value={assigneeId}
				onChange={(val) => setAssigneeId(val)}
				onBlur={() => setTouched(true)}
				errors={isInvalid ? "Assignee is required" : ""}
				touched={touched}
				optionRender={(option) => (
					<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
						{option.data.avatar ? (
							<img
								src={option.data.avatar}
								alt={option.label}
								style={{ width: 24, height: 24, borderRadius: "50%" }}
							/>
						) : (
							<UserOutlined
								style={{ width: 24, height: 24, borderRadius: "50%" }}
							/>
						)}
						<span>{option.label}</span>
					</div>
				)}
			/>
			<div
				className="neutral-400"
				style={{
					background: "#f5f7f6",
					borderRadius: 8,
					padding: "10px 12px",
					fontSize: 13,
					marginTop: 12,
				}}
			>
				{trans(
					"Task status is unchanged. Planned date and the link to each original request stay the same.",
				)}
			</div>
		</Modal>
	);
}
